export const ERROR_NOT_INITIALIZED =
  'Error sending event. Have you forget to call init({context,visitId})?';
export const ERROR_COMPONENT_ID_MANDATORY = 'error : Component ID is mandatory';
export const ERROR_COMPONENT_DOM_MANDATORY =
  'error : param should be an instance of Element';
export const ERROR_EVENT_MANDATORY = 'error : param should be a click Event';
